import { Component, Input } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { ButtonVariants } from '../../models/button.model';

@Component({
  selector: 'app-compound-button',
  imports: [SharedModule, HlmButtonDirective],
  standalone: true,
  templateUrl: './compound-button.component.html',
})
export class CompoundButtonComponent {
  @Input({ required: true }) title: string;
  @Input() icon: string = 'arrow-right';
  @Input() btnVariant: ButtonVariants = 'default';
}
